import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type { VirtualPageViewEvent } from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const VIRTUAL_PAGE_VIEW_EVENT_NAME = 'virtual_page_view'

export const triggerVirtualPageViewEvent = (event: VirtualPageViewEvent) =>
  triggerEvent(VIRTUAL_PAGE_VIEW_EVENT_NAME, event)

export const onVirtualPageViewEvent = (
  callback: EventCallback<VirtualPageViewEvent>
) => subscribeEvent(VIRTUAL_PAGE_VIEW_EVENT_NAME, callback)

export const removeVirtualPageViewEvent = (
  token: EventToken<VirtualPageViewEvent>
) => unsubscribeEvent(VIRTUAL_PAGE_VIEW_EVENT_NAME, token)
